import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { CMTableList } from '../../components/common/TableList/TableList';
import { PageRoutes } from '../../constants';
import { AppContext } from '../../components/common/Helpers/Context/AppContext';
import { deleteUsers, listUsers, usersStatus } from './UsersServices';

const UsersList = () => {

    const { globalData, setGlobalData } = React.useContext(AppContext);

    const columns: readonly any[] = [
        { key: "id", label: "ID", minWidth: 170 },
        { key: "f_name", label: "First Name", minWidth: 170 },
        { key: "l_name", label: "Last Name", minWidth: 170 },
        { key: "mobile_number", label: " Mobile Number", minWidth: 170 },
        { key: "email", label: "Email", minWidth: 170 },
        { key: "address", label: "Address", minWidth: 170 },
        { key: "status", label: "Status", minWidth: 170 },
    ];

    React.useEffect(() => {
        setGlobalData({
            ...globalData,
            loading: true
        })
        listUsers().then((res: any) => {
            setGlobalData({
                ...globalData,
                loading: false
            })
        }).catch((err: any) => {
            console.log(err)
            setGlobalData({
                ...globalData,
                loading: false,
                error: true,
                errorMessage: "Failed to load data"
            });
        })
    }, [])
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <PageHeader header='Admin User' list={true} link={PageRoutes.USERS_ADD} value={"Add Admin User"} />
                            <CMTableList
                                // exportFileName="Office Branch"
                                // csvHeaders={["ID", "Name", "Removed"]}
                                // csvHeaderKeys={["id", "name", "removed"]}
                                blockService={usersStatus}
                                listService={listUsers}
                                deleteService={deleteUsers}
                                showView={false}
                                showBlock={false}
                                editLink={PageRoutes.USERS_EDIT}
                                columns={columns}
                                deleteAccess={true}
                                editAccess={true}
                            />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default UsersList;
